import React from 'react';
import cx from 'classnames';
// import PropTypes from 'prop-types'
import { InputMultiSelectStyled } from './styled';
import Select from 'react-select';
import theme from 'styles/theme.json';

const InputMultiSelect = ({
  theme_standard,
  label,
  options,
  onChange,
  placeholder,
  defaultValue,
}) => {
  // defaultValue รับเป็น string คั่นด้วย , (แบบเดียวกับที่ส่งขึ้น query) เพื่อคืนค่าที่เคยเลือกไว้
  // ถ้ายังหา option ไม่เจอ (options ยังโหลดไม่เสร็จ) ใช้ค่าเองเป็น label ไปก่อน
  const initialValue = defaultValue
    ? String(defaultValue)
        .split(',')
        .filter((e) => e)
        .map(
          (value) =>
            (options || []).find((o) => String(o.value) === value) || {
              label: value,
              value,
            }
        )
    : undefined;

  const customClass = cx({
    theme_standard: theme_standard,
  });

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      borderBottom: `1px dotted ${theme.COLORS.GRAY_1}`,
      // color: state.isSelected ? 'red' : 'blue',
      padding: 20,
    }),
    control: () => ({
      // none of react-select's styles are passed to <Control />
      // width: 200,
      borderRadius: '1rem',
      border: `0.0625rem solid ${theme.COLORS.GRAY_1}`,
      minHeight: '2.65rem',
      display: 'flex',
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    },
  };

  return (
    <InputMultiSelectStyled>
      <div className={customClass}>
        {label && <div className="label">{label}</div>}
        <Select
          isMulti
          styles={customStyles}
          placeholder={placeholder}
          defaultValue={initialValue}
          onChange={onChange}
          options={options}
        />
      </div>
    </InputMultiSelectStyled>
  );
};

InputMultiSelect.propTypes = {};

export default InputMultiSelect;
